export default "__VITE_ASSET__cdeebe10__"